module.exports = __webpack_public_path__ + "static/media/GelBoxTop.562ee608.svg";